
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 33c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm0-13.5c-3 0-5.5 2.4-5.5 5.5 0 3 2.4 5.5 5.5 5.5 3 0 5.5-2.4 5.5-5.5 0-3-2.5-5.5-5.5-5.5z"}}),_c('path',{attrs:{"d":"M29.2 48.3h-8.4l-.4-6.7c-1.4-.4-2.7-.9-3.9-1.6l-5 4.5-5.9-5.9 4.5-5c-.7-1.2-1.2-2.5-1.6-3.9l-6.7-.4v-8.4l6.7-.4c.4-1.4.9-2.7 1.6-3.9l-4.5-5 5.9-5.9 5 4.5c1.2-.7 2.5-1.2 3.9-1.6l.4-6.7h8.4l.4 6.7c1.4.4 2.7.9 3.9 1.6l5-4.5 5.9 5.9-4.5 5c.7 1.2 1.2 2.5 1.6 3.9l6.7.4v8.4l-6.7.4c-.4 1.4-.9 2.7-1.6 3.9l4.5 5-5.9 5.9-5-4.5c-1.2.7-2.5 1.2-3.9 1.6l-.4 6.7zm-6-2.5h3.6l.3-6.2.9-.2c1.7-.4 3.4-1 4.8-2l.8-.5 4.7 4.2 2.6-2.6-4.2-4.7.5-.8c1-1.5 1.6-3.1 2-4.8l.2-.9 6.2-.3v-3.6l-6.2-.3-.2-.9c-.4-1.7-1-3.4-2-4.8l-.5-.8 4.2-4.7L38.4 9l-4.7 4.2-.8-.5c-1.5-1-3.1-1.6-4.8-2l-.9-.2-.3-6.2h-3.6l-.3 6.2-.9.2c-1.7.4-3.4 1-4.8 2l-.8.5L11.6 9 9 11.6l4.2 4.7-.5.8c-1 1.5-1.6 3.1-2 4.8l-.2.9-6.2.3v3.6l6.2.3.2.9c.4 1.7 1 3.4 2 4.8l.5.8L9 38.4l2.6 2.6 4.7-4.2.8.5c1.5 1 3.1 1.6 4.8 2l.9.2.4 6.3z"}})])
          )
        }
      }
    